import React from 'react';
interface FeaturedDepartmentsProps {
  onNavigate: (page: 'shop') => void;
}
export function FeaturedDepartments({
  onNavigate
}: FeaturedDepartmentsProps) {
  const departments = [{
    title: 'Dogs & Puppies',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80'
  }, {
    title: 'Cats & Kittens',
    image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=600&q=80'
  }, {
    title: 'Birds & Poultry',
    image: 'https://images.unsplash.com/photo-1552728089-57bdde30beb3?w=600&q=80'
  }, {
    title: 'Fish',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&q=80'
  }, {
    title: 'Small Animals',
    image: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?w=600&q=80'
  }, {
    title: 'Garden Care',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80'
  }, {
    title: 'Pools & Spas',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600&q=80'
  }];
  return <section className="section-padding bg-white" data-id="element-113">
      <div className="container-wide" data-id="element-114">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-115">
          <div className="max-w-2xl" data-id="element-116">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-117">
              Shop by Department
            </h2>
            <p className="text-lg text-gray-600" data-id="element-118">
              Everything for your pets, garden and pool — all under one roof.
            </p>
          </div>
          <button onClick={() => onNavigate('shop')} className="text-brand-blue font-heading font-bold hover:text-brand-blue-700 transition-colors flex items-center gap-2 group" data-id="element-119">
            View All Categories
            <span className="transform group-hover:translate-x-1 transition-transform" data-id="element-120">
              →
            </span>
          </button>
        </div>

        {/* Top row: 4 tiles. Bottom row: 3 tiles centered */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4 md:mb-6" data-id="element-121">
          {departments.slice(0, 4).map((dept, index) => <div key={index} className="relative rounded-2xl overflow-hidden cursor-pointer group aspect-square md:aspect-[4/3] shadow-sm hover:shadow-elevated transition-all duration-500" onClick={() => onNavigate('shop')} data-id="element-122">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{
            backgroundImage: `url(${dept.image})`
          }} data-id="element-123"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-124"></div>
              <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end" data-id="element-125">
                <h3 className="font-heading font-bold text-lg md:text-2xl text-white mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-126">
                  {dept.title}
                </h3>
                <div className="opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 text-brand-green-300 font-medium flex items-center gap-1 text-sm" data-id="element-127">
                  Shop Now <span className="text-lg leading-none" data-id="element-128">→</span>
                </div>
              </div>
            </div>)}
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-129">
          {departments.slice(4).map((dept, index) => <div key={index + 4} className={`relative rounded-2xl overflow-hidden cursor-pointer group aspect-square md:aspect-[4/3] shadow-sm hover:shadow-elevated transition-all duration-500 ${index === 2 ? 'col-span-2 lg:col-span-1' : ''}`} onClick={() => onNavigate('shop')} data-id="element-130">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{
            backgroundImage: `url(${dept.image})`
          }} data-id="element-131"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-132"></div>
              <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end" data-id="element-133">
                <h3 className="font-heading font-bold text-lg md:text-2xl text-white mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-134">
                  {dept.title}
                </h3>
                <div className="opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 text-brand-green-300 font-medium flex items-center gap-1 text-sm" data-id="element-135">
                  Shop Now <span className="text-lg leading-none" data-id="element-136">→</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}